<template>
  <div style="padding: 20px; background: #fff" v-if="isShowFooterBtnPanel">
    <template v-for="(item, index) of curBtnList">
      <el-button
        v-if="!item.disabled"
        :type="item.type"
        :key="index"
        :disabled="item.disabled"
        @click="clickHandler(item.clickName, item.params)"
        class="fixed-bottom-btn"
        >{{ item.title }}
      </el-button>
    </template>
  </div>
</template>
<script>
  export default {
    name: 'DetailFooterButtons',
    props: {
      pageMode: {
        type: Number,
        default: 0,
      },
      projectStatus: {
        type: String,
        default: () => '',
      },
    },
    data() {
      return {
        allBtnList: [
          {
            title: '保存',
            type: 'primary',
            clickName: 'save',
            params: 0,
            key: 'save',
          },
          {
            title: '编辑',
            type: 'primary',
            clickName: 'edit',
            params: 0,
            key: 'edit',
          },
          {
            title: '查看',
            type: 'primary',
            clickName: 'view',
            params: 0,
            key: 'view',
          },
          {
            title: '项目转合同',
            type: 'primary',
            clickName: 'convert',
            params: 0,
            key: 'convert',
          },
          {
            title: '提交',
            type: 'primary',
            clickName: 'save',
            params: 1,
            key: 'submit',
          },
          {
            title: '作废',
            type: 'primary',
            clickName: 'revoke',
            params: 1,
            key: 'revoke',
          },
          {
            title: '取消',
            type: 'primary',
            clickName: 'cancel',
            params: 1,
            key: 'cancel',
          },
        ],
        curBtnList: [],
        isShowFooterBtnPanel: true,
      };
    },
    methods: {
      // 动态派发事件上去
      clickHandler(clickName, params) {
        this.$emit('btnHandler', clickName, params);
      },
      buttonStatusChange(pageMode, projectStatus) {
        this.curBtnList = this.allBtnList.map((item) => {
          if (pageMode == 0) {
            if (['submit', 'save', 'cancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else {
            let list = [];
            if (
              projectStatus == '' ||
              projectStatus == '审批通过' ||
              projectStatus == '草稿' ||
              projectStatus == '项目执行中' ||
              projectStatus == '审批驳回'
            ) {
              if (pageMode == 2) {
                list.push('view');
              } else {
                list.push('edit');
              }
            }
            if (projectStatus == '' || projectStatus == '审批通过') {
              list.push('convert');
            }

            if (
              projectStatus == '' ||
              projectStatus == '草稿' ||
              projectStatus == '项目执行中' ||
              projectStatus == '审批驳回'
            ) {
              if (pageMode == 2) {
                list.push('save', 'submit');
              }
            }

            if (projectStatus == '' || projectStatus == '审批通过') {
              if (pageMode == 2) {
                list.push('submit');
              }
            }
            if (
              projectStatus == '' ||
              projectStatus == '审批通过'
              // projectStatus == '项目执行中'
            ) {
              list.push('revoke');
            }
            list.push('cancel');

            if (projectStatus == '审批中' || projectStatus == '已作废') {
              list = [];
              list.push('cancel');
            }

            if (list.includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          }
        });
        this.isShowFooterBtnPanel = !this.curBtnList.every((item) => item.disabled);
      },
    },
    watch: {
      pageMode: {
        handler(val, oldVal) {
          if (val == oldVal) {
            return;
          }
          this.buttonStatusChange(val, this.projectStatus);
        },
        immediate: true,
      },
      projectStatus: {
        handler(val, oldVal) {
          if (val == oldVal) {
            return;
          }
          this.buttonStatusChange(this.pageMode, val);
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
